import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ChatType } from "../../components/ccOS/Recorder";

const OrderComplete = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData;

  const [ttsInstance, setTtsInstance] = useState<any>(null); // ttsInstance

  const playChatTTS = async () => {
    if (window.ccOS) {
      ttsInstance.speak("결제가 완료되었어요");
    }
  };

  useEffect(() => {
    if (window.ccOS) {
      window.ccOS.TextToSpeech.getInstance().then((instance: any) => {
        setTtsInstance(instance);
      });
    }
  }, []);

  useEffect(() => {
    if (ttsInstance !== null) {
      playChatTTS();
    }
  }, [ttsInstance]);

  return (
    <Style>
      <div className="wrapper">
        <img
          src={`${process.env.PUBLIC_URL}/svg/ic_success_blue.svg`}
          alt="success"
        />
        <h1>{orderData.payment_arrival_time}분 후 픽업 예정입니다</h1>
        <h2>
          {"결제가 완료되었습니다\n주행 중에도 남은 시간과 거리를 알려드릴게요"}
        </h2>
        <button
          className="successButton"
          onClick={() =>
            navigate("/map", { state: { orderData }, replace: true })
          }
        >
          확인
        </button>
      </div>
    </Style>
  );
};

export default OrderComplete;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
  h1 {
    font-size: 64px;
    line-height: 90px;
    color: #6490e8;
    font-weight: 600;
  }
  h2 {
    font-size: 32px;
    line-height: 50px;
    font-weight: 500;
    white-space: pre-line;
    text-align: center;
  }
  button {
    width: auto;
  }
  /* 결제하기버튼 */
  .successButton {
    margin-top: 40px;
    padding: 20px 16%;
    border-radius: 20px;
  }
`;
